module.exports = __webpack_public_path__ + "static/media/kudos-right-arrow-icon.8d371dac.svg";